module.exports = __webpack_public_path__ + "static/media/29ADMSPC37.759836f3.jpg";